<template>
  <div class="row section flow__page" :class="{ 'flow__page--ready': isReady }">
    <div class="col section__content">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, getCurrentInstance, nextTick, PropType, ref } from 'vue';
import { defaultEnterAnimation, defaultLeaveAnimation, FlowAnimation } from '@/components/Flow/Types';
import { recursivelyWaitForPromises } from '@/utilities/virtualDom';
import { scrollFlowIntoFocus } from '@/utilities/Flow';

export default defineComponent({
  name: 'FlowPage',
  components: {},
  inheritAttrs: false,
  props: {
    animationEnter: {
      type: Object as PropType<FlowAnimation>,
      default: () => {
        return defaultEnterAnimation;
      }
    },
    animationLeave: {
      type: Object as PropType<FlowAnimation>,
      default: () => {
        return defaultLeaveAnimation;
      }
    }
  },
  setup(props) {
    const isReady = ref(false);
    const currentInstance = getCurrentInstance();
    let readyPromiseResolve: (() => void) | undefined;

    const readyPromise = new Promise<void>((resolve) => {
      readyPromiseResolve = resolve;
    });

    const enterAnimation = (): FlowAnimation => {
      return props.animationEnter;
    };

    const leaveAnimation = (): FlowAnimation => {
      return props.animationLeave;
    };

    nextTick(async () => {
      if (currentInstance?.vnode) {
        await recursivelyWaitForPromises(currentInstance.vnode, 'onBeforeEnter', 3);
      }

      if (readyPromiseResolve) {
        isReady.value = true;

        scrollFlowIntoFocus();
        readyPromiseResolve();
      }
    });

    return {
      enterAnimation,
      leaveAnimation,
      isReady,
      onBeforeEnter: async () => {
        await readyPromise;
      }
    };
  }
});
</script>
